import { render, staticRenderFns } from "./voiceConsultation.vue?vue&type=template&id=0e07b91e&scoped=true"
import script from "./voiceConsultation.vue?vue&type=script&lang=js"
export * from "./voiceConsultation.vue?vue&type=script&lang=js"
import style0 from "./voiceConsultation.vue?vue&type=style&index=0&id=0e07b91e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e07b91e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e07b91e')) {
      api.createRecord('0e07b91e', component.options)
    } else {
      api.reload('0e07b91e', component.options)
    }
    module.hot.accept("./voiceConsultation.vue?vue&type=template&id=0e07b91e&scoped=true", function () {
      api.rerender('0e07b91e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/wenzhen/voiceConsultation.vue"
export default component.exports